module.exports = __webpack_public_path__ + "img/td-icon2.da8cefac.png";